import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getCommunityFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How many food ${vehicleType}s do I need for an event or festival?`,
    answer: `The number of food ${vehicleType}s needed depends on your attendance, event length, and service style. As a general guideline, one food ${vehicleType} can serve 75–150 people per hour. Large festivals, street fairs, and concerts often book multiple ${vehicleType}s to reduce lines and offer variety. ${siteTitle} can help you determine the right number of ${vehicleType}s for events ranging from 50 to 50,000+ guests.`
  },
  {
    question: `How much does it cost to hire food ${vehicleType}s for events or festivals in ${cityName}?`,
    answer: `Event and festival food ${vehicleType} costs vary based on attendance, duration, vendor mix, and whether ${vehicleType}s pay fees, percentages, or operate independently. ${siteTitle} connects you directly with food ${vehicleType}s so you can discuss pricing structures, availability, and logistics upfront—without added service fees or commissions.`
  },
  {
    question: `Can I book multiple food ${vehicleType}s for one event or festival?`,
    answer: `Yes. Many events book multiple food ${vehicleType}s to provide menu variety and handle large crowds. ${siteTitle} gives you access to over 500 food ${vehicleType}s, making it easy to book one ${vehicleType} for a small community event or curate a lineup of vendors for large festivals and markets.`
  },
  {
    question: `Do food ${vehicleType}s handle permits, insurance, and health requirements for events?`,
    answer: `Food ${vehicleType}s operating through ${siteTitle} are licensed and insured, and familiar with local health department requirements. Depending on your event type and location, additional permits or approvals may be required. Our team can help guide organizers and coordinate details with vendors to ensure a smooth and compliant event.`
  },
  {
    question: `What types of events are food ${vehicleType}s best suited for?`,
    answer: `Food ${vehicleType}s are ideal for festivals, farmers markets, school events, fundraisers, street fairs, concerts, block parties, store openings, and community celebrations. They offer flexible setup, fast service, and a wide range of cuisines, making them a reliable solution for events of all sizes.`
  },
  {
    question: `How far in advance should I book food ${vehicleType}s for an event or festival?`,
    answer: `For best availability, we recommend booking food ${vehicleType}s 1–3 months in advance for large events and festivals, especially during peak season. Smaller events may have more flexibility. Submitting your request early allows you to secure your preferred vendors and plan logistics confidently.`
  }
];

function CommunityFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getCommunityFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default CommunityFaq;
